import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { Trash, CartPlus, Eye, HeartFill, ArrowLeft } from 'react-bootstrap-icons';
import { useAuth } from '../../context/authContext';
import './WishlistPage.css';
const API = process.env.REACT_APP_API_URL;
const WishlistPage = () => {
    const [wishlistItems, setWishlistItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const { fetchWishlist, wishlist, fetchCart ,handleRemoveFromWishlist} = useAuth(); // Assuming fetchCart exists to update cart count
    const navigate = useNavigate();
    // Sync state with Context
    useEffect(() => {
        fetchWishlist();
    }, []);

    useEffect(() => {
        
        if (wishlist) {
            // Map context data to component state
            const mapped = wishlist.map(p => ({
                ...p,
                id: p.product_id,
                image: p.image || 'https://via.placeholder.com/300', // Fallback image
                stock: p.in_stock,
                price: p.price || 0, // Ensure price exists
                description: p.short_description
            }));
            setWishlistItems(mapped);
            setLoading(false);
        }
        console.log("Wishlist from context:", wishlist);
    }, [wishlist]);

    const handleMoveToCart = async (product) => {
        const token = localStorage.getItem('token');
        if (!token) return toast.warning("Please login first");

        try {
            // 1. Add to Cart
            const cartRes = await fetch(`${API}/api/cart/add`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                body: JSON.stringify({ product_id: product.id, quantity: 1 })
            });

            if (cartRes.ok) {
                toast.success(<span>Added <b>{product.name}</b> to Cart!</span>);
                if (fetchCart) fetchCart(); 
            } else {
                toast.error("Failed to add to cart");
            }
        } catch (err) {
            console.error(err);
            toast.error("Something went wrong");
        }
    };

    if (loading) {
        return (
            <div className="wishlist-loading">
                <div className="spinner"></div>
                <p>Loading your favorites...</p>
            </div>
        );
    }

    return (
        <div className="wishlist-wrapper">
            <div className="wishlist-container">
                {/* Header */}
                <div className="wishlist-header">
                    <h1>
                        <HeartFill className="header-icon" /> 
                        My Wishlist 
                        <span className="count-badge">{wishlistItems.length}</span>
                    </h1>
                    <Link to="/" className="back-link"><ArrowLeft /> Continue Shopping</Link>
                </div>

                {/* Content */}
                {wishlistItems.length === 0 ? (
                    <div className="empty-wishlist">
                        <div className="empty-icon-bg">
                            <HeartFill />
                        </div>
                        <h3>Your wishlist is empty</h3>
                        <p>Seems like you don't have wishes here. Make a wish!</p>
                        <button onClick={() => navigate('/')} className="btn-start-shopping">
                            Start Shopping
                        </button>
                    </div>
                ) : (
                    <div className="wishlist-grid">
                        {wishlistItems.map(item => (
                            <div key={item.id} className={`wishlist-card ${!item.stock ? 'out-of-stock-card' : ''}`}>
                                
                                {/* Image Area */}
                                <div className="card-image-wrapper">
                                    <Link to={`/product/${item.id}`}>
                                        <img src={`${API}${item.image}`} alt={item.name} />
                                    </Link>
                                    {!item.stock && <div className="stock-overlay">Out of Stock</div>}
                                    
                                   {/* Wishlist Heart Icon */}
                                   <div
  className="wishlist-heart"
  onClick={(e) => {
    e.stopPropagation();
    handleRemoveFromWishlist(item.id);
    toast.success("Removed from wishlist");
  }}
  title="Remove from wishlist"
>
  <HeartFill />
</div>



                                </div>

                                {/* Details Area */}
                                <div className="card-details">
                                    <h3 className="product-name" title={item.name}>{item.name}</h3>
                                    <p className='cat-name'>{item.category}</p>
                                    <div className="price-row">
                                        <span className="price">₹{Number(item.price).toFixed(2)}</span>
                                        {item.stock ? (
                                            <span className="status in">In Stock</span>
                                        ) : (
                                            <span className="status out">Sold Out</span>
                                        )}
                                    </div>

                                    <button 
                                        className="btn-move-cart"
                                        onClick={() => handleMoveToCart(item)}
                                        disabled={!item.stock}
                                    >
                                        <CartPlus /> Add to Cart
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default WishlistPage;